import { useEffect, useRef } from "react"
import { useRouter } from "next/router"
import Script from "next/script"
import { useTranslations } from "use-intl"
import { RECAPTCHA_SJ_KEY_V3 } from "env"

export default function Recaptcha({ onRecaptchaChange, action = "submit", recaptchaSiteKey }) {
  const t = useTranslations("Shared")
  const scriptLoaded = useRef(false)
  const scriptInitialized = useRef(false)
  
  const executeRecaptcha = async () => {

    try {
      // Wait for script to be available if needed
      if (!window.grecaptcha) {
        await new Promise(resolve => {
          const checkScript = () => {
            if (window.grecaptcha) {
              resolve();
            } else {
              setTimeout(checkScript, 100);
            }
          };
          checkScript();
        });
      }
      
      const token = await window.grecaptcha.execute(recaptchaSiteKey, { action })
      onRecaptchaChange(token)
    } catch (error) {
      onRecaptchaChange(null)
    }
  }

  useEffect(() => {
    const initializeAndExecute = async () => {
      try {
        // If script was previously loaded
        if (window.grecaptcha?.ready) {
          await executeRecaptcha();
          return;
        }

        // If script is not loaded yet
        if (!scriptInitialized.current) {
          const script = document.createElement('script');
          script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
          script.async = true;
          script.defer = true;
          
          script.onload = () => {
            window.grecaptcha.ready(async () => {
              await executeRecaptcha();
            });
          };
          
          document.head.appendChild(script);
          scriptInitialized.current = true;
        }
      } catch (error) {
        console.error("Error initializing reCAPTCHA:", error);
      }
    };

    initializeAndExecute();

    return () => {
      // Just hide the badge on unmount, don't remove it
      const badges = document.getElementsByClassName('grecaptcha-badge');
      if (badges.length > 0) {
        badges[0].style.visibility = 'hidden';
      }
    };
  }, [action])

  return (
    <>

      <div className="text-sm text-gray-600 mt-4">
        {t.rich("recaptchaDisclaimer", {
          a: (chunks) => (
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              {chunks}
            </a>
          ),
          b: (chunks) => (
            <a
              href="https://policies.google.com/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              {chunks}
            </a>
          )
        })}
      </div>
    </>
  )
}
